import React, { useState } from 'react';
import '../../styles/team/tribe-member.scss';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

function TribeMember(props) {
  const [tribePhoto, setTribePhoto] = useState(props.image);

  return (
    <div className="col">
      <img
        onMouseEnter={() => {
          ReactGA.pageview(props.name);
          ReactPixel.trackCustom(props.name);
          setTribePhoto(props.hoveredImage);
        }}
        onMouseLeave={() => setTribePhoto(props.image)}
        className="tribe-member-photo"
        src={tribePhoto}
        alt="Human being"
      />
    </div>
  );
}

export default TribeMember;
